module.exports = __webpack_public_path__ + "static/img/qr.48d50666.png";